/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1440,
  },
}

export default breakpoints
